// extracted by mini-css-extract-plugin
export var card = "_nc-0";
export var content = "_nc-2";
export var details = "_nc-3";
export var icon = "_nc-1";
export var iconBlue = "_nc-5";
export var iconBrand = "_nc-4";
export var iconGrayBlue = "_nc-6";
export var iconGreen = "_nc-7";
export var iconIndigo = "_nc-8";
export var iconOrange = "_nc-9";
export var iconPurple = "_nc-a";
export var iconRed = "_nc-b";
export var iconWarning = "_nc-c";